import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { Col, Row } from "antd";
import { color } from "../../utils/themes/color";
import loginVector from "./../../assets/images/loginVector.png"
import loginIcon from './../../assets/images/loginIcon.png';
import INPUT from '../../components/input/input';
import BUTTON from '../../components/buttons/button';
import Axios from "./../../utils/api/axiosConf";
import { url } from './../../utils/api/api';
import { RedNotif, GreenNotif } from "../../utils/utils";
import { useNavigate } from "react-router-dom";


export default function Login() {

    const [height, setHeight] = useState(window.innerHeight);
    const [user, setuser] = useState({
        userName: "",
        password: ""
    })
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);



    window.onresize = function (e) {
        setHeight(window.innerHeight)
    }

    const Login = () => {
        if (user.userName != "" && user.password) {
            setLoading(true);
            Axios.post(`${url}users/login`, user)
                .then(async (response) => {
                     if (response.status === 200 || response.status === 201) {
                        await localStorage.setItem('AccessToken', response.data.tokens.accessToken);
                        await localStorage.setItem('RefreshToken', response.data.tokens.refreshToken);
                        await navigate('/');
                        GreenNotif(response.message);
                        setLoading(false);
                    } else {
                        RedNotif(response.message);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading(false)
                });

        } else {
            RedNotif("نام کاربری و رمز عبور نمی توانند خالی باشند")
        }




    }

    if (localStorage.getItem('AccessToken') != null && localStorage.getItem('AccessToken') !== "" && localStorage.getItem('AccessToken') !== undefined) {
        window.location.replace("/");

    } else {
        return (
            <Row  style={{ justifyContent: 'center', width: "100%", height: height, background: color.primary }}>
                <Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24} style={{ height: height * .7 > 400 ? height * 0.7 : 400, background: color.primaryContainer, margin: "80px 0" }} >
                    <Row style={{ width: "100%", height: "100%" }}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ display: "flex", alignItems: 'center' }}>
                            <img src={loginVector} style={{ width: "100%" }} />
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} 
                        style={{ 
                            background: color.secondaryContainer, 
                            display: "flex", 
                            alignItems: 'center', 
                            flexDirection: 'column', 
                            justifyContent: 'center' ,
                            padding:"25px"
                            
                            }}>

                            <img src={loginIcon} />
                            <br/>
                            <p style={{ color: color.primary, margin: "20px 0" }}>ورود به پنل مدیریت جیمک</p>
                            <br/>
                            <INPUT i={(e) => { setuser({ ...user, userName: e }) }} />
                            <br/>
                            <INPUT i={(e) => { setuser({ ...user, password: e }) }} type={"password"} />
                            <br/>
                            <BUTTON event={(e) => { Login() }} text="ورود به پنل" loading={loading} />
                        </Col>
                    </Row>
                </Col>
            </Row >
        )
    }
}